<template>
  <v-form ref="fm_work_info">
      <v-card outlined tile elevation="2" class="mt-2">
          <v-card-title class="font-weight-light mb-2 pb-0">Work Information</v-card-title>
          <v-card-text>
            <v-row class="my-2">
                <v-col cols="12" class="py-0 pb-2">
                    <v-radio-group
                        ref="oma_multiple_school_districts_ind"
                        v-model="oma_multiple_school_districts_ind"
                        :rules="rules.oma_multiple_school_districts_ind"
                        row
                        :dense="$vuetify.breakpoint.mdAndUp"
                        required
                    >
                        <template v-slot:label>
                            <div>Are you employed at more than one district/institution? <span class="required red--text"> *</span></div>
                        </template>
                        <v-radio
                            label="Yes"
                            value="1"
                        ></v-radio>
                        <v-radio
                            label="No"
                            value="0"
                        ></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
            <v-row class="my-2">
                <v-col cols="12" sm="6" class="py-0">
                    <v-autocomplete
                        ref="oma_school_district_id"
                        v-model="oma_school_district_id"
                        :items="district_options"
                        item-text="dist_name"
                        item-value="dist_cst_recno"
                        :loading="district_options.length == 0"
                        :dense="$vuetify.breakpoint.mdAndUp"
                        :rules="rules.oma_school_district_id"
                        v-on:change="determine_building_options();"
                    >
                        <template #label>
                            Which institution do you work for?<span class="required red--text"> *</span>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" class="py-0">
                    <v-autocomplete
                        class="d-none"
                        ref="oma_school_building_id"
                        v-model="oma_school_building_id"
                        :items="building_options"
                        item-text="bldg_name"
                        item-value="bldg_cst_recno"
                        :disabled="building_options.length == 0"
                        :rules="rules.oma_school_building_id"
                        :dense="$vuetify.breakpoint.mdAndUp"
                        label="Which building do you work in?"
                    >
                        <template #label>
                            Which building do you work in?<span class="required red--text"> *</span>
                        </template>
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row class='my-2'>
                <v-col cols="12" class="py-0">
                    <v-select
                        ref="oma_job_classification"
                        v-model="oma_job_classification"
                        :items="job_class_options"
                        item-text="jc_name"
                        item-value="jc_name"
                        :loading="job_class_options.length == 0"
                        :rules="rules.oma_job_classification"
                        :dense="$vuetify.breakpoint.mdAndUp"
                        label="Which job classification best represents your work?"
                    >
                    <template #label>
                        Which job classification best represents your work?<span class="required red--text"> *</span>
                    </template>
                    </v-select>
                </v-col>
            </v-row>
            <v-row class="my-2">
                <!--
                <v-col cols="12" sm="4" class="py-0">
                    <v-menu
                        ref="oma_hiredate_menu"
                        v-model="oma_hiredate_menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="auto"
                        >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formatISOHireDate"
                                :rules="rules.oma_hiredate"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                >
                                <template #label>
                                   Dues Start Date<span class="required red--text"> *</span>
                                </template>
                                <template v-slot:append>
                                    <v-btn @click="oma_hiredate_menu=true;" x-small text tabindex="-1">
                                        <font-awesome-icon :icon="{prefix:'far', iconName:'calendar-alt'}" size="lg" />
                                    </v-btn>
                                </template>
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="oma_hiredate"
                            type="month"
                            no-title
                            @input="oma_hiredate_menu = false;"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
            -->
                <v-col cols="12" sm="8" class="py-0">
                    <v-text-field
                        ref="oma_work_email"
                        v-model="oma_work_email"
                        type="email"
                        :rules="rules.oma_work_email"
                        validate-on-blur
                    >
                    <template #label>
                        Work Email
                    </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row class="my-2">
                <v-col cols="12" sm="8" class="py-0">
                    <v-text-field
                        ref="oma_work_phone"
                        v-model="oma_work_phone"
                        v-mask="masks.phone"
                        required
                        type="tel"
                        :rules="rules.oma_work_phone"
                    >
                    <template #label>
                        Work Phone Number
                    </template>
                    </v-text-field>
                </v-col>
                <v-col cols="12" sm="4" class="py-0">
                    <v-text-field
                        ref="oma_work_phone_ext"
                        v-model="oma_work_phone_ext"
                        type="number"
                        inputmode="numeric"
                        hide-spin-buttons
                        :rules="rules.oma_work_phone_ext"
                    >
                    <template #label>
                        Work Extension
                    </template>
                    </v-text-field>
                </v-col>
            </v-row>
          </v-card-text>
      </v-card>
      <v-row class="justify-center">
        <v-col cols="12" class="d-flex flex-column flex-md-row justify-space-between">
            <v-btn
                color="grey darken-3"
                tile
                @click="$emit('go-back')"
                dark
                class='my-2'
            >
                Go Back
            </v-btn>

            <v-btn
                color="rgb(0 48 87)"
                tile
                @click="validate_and_continue"
                dark
                class='my-2'
            >
                Continue to Step 3
            </v-btn>
        </v-col>
    </v-row>
    <errors-on-form-dialog :showDialog="showErrorsOnPage" @close-dialog="showErrorsOnPage=false;"></errors-on-form-dialog>
    <saving-progress-dialog :showDialog="showSavingProgress"></saving-progress-dialog>
    <multiple-districts-dialog :showDialog="showMultipleDistrict" @close-dialog="showMultipleDistrict=false;multipleDistrictsShown=true;"></multiple-districts-dialog>
    <multiple-possible-units-dialog :showDialog="showMultiplePossibleUnits" :potentialUnits="potentialUnits" @close-dialog="set_bargaining_unit"></multiple-possible-units-dialog>
    <error-dialog :showDialog="showError" :errorObject="errorObj" :errorIsFatal="errorIsFatal" @close-dialog="showError=false;"></error-dialog>
  </v-form>
</template>

<script>
  import axios from 'axios'
  import ErrorsOnFormDialog from './DialogComponents/ErrorsOnFormDialog.vue'
  import SavingProgressDialog from './DialogComponents/SavingProgressDialog.vue'
  import MultipleDistrictsDialog from './DialogComponents/MultipleDistrictsDialog.vue'
  import MultiplePossibleUnitsDialog from './DialogComponents/MultiplePossibleUnitsDialog.vue'
  import ErrorDialog from './DialogComponents/ErrorDialog.vue'
  import commonMixins from '@/mixins/commonMixins'
  export default {
    name: 'WorkInfo',
    mixins:[commonMixins],
    components:{ErrorsOnFormDialog, SavingProgressDialog, MultipleDistrictsDialog, MultiplePossibleUnitsDialog, ErrorDialog},
    data:() => ({
        showErrorsOnPage: false,
        showSavingProgress : false,
        showMultipleDistrict: false,
        showError: false,
        errorObj:{},
        errorIsFatal: false,
        checked_for_bu: false,
        multipleDistrictsShown: false, //we only need this to show once so set this to true once it's shown
        showMultiplePossibleUnits: false,
        potentialUnits: [],
        district_options:[],
        building_options: [],
        job_class_options: [],
        oma_hiredate_menu: false,
        rules: {
            oma_multiple_school_districts_ind:[
                v => !!v || 'This field is required',
                v => /^[01]$/.test(v) || 'Response is invalid'
            ],
            oma_school_district_id:[
                v => !!v || 'District is required'
            ],
            oma_school_building_id:[
                v => !!v || 'Building is required',
                v => /^\d{6}$/.test(v) || 'Building is invalid'
            ],
            oma_job_classification:[
                v => !!v || 'Job Classification is required',
                v => /^([\w\s.,%#&()/'-]+)$/.test(v) || 'Job Classificaiton is invalid'
            ],
            /*
            oma_hiredate:[
                v => !!v || 'Dues Start Date is required',
                v => /^\d{2}\/\d{4}$/.test(v) || 'Dues Start Date is invalid'
            ],*/
            oma_work_email:[
                v => {
                    if(v) return /^\S+@\S+\.\S+$/.test(v) || 'Work email is invalid';
                    else return true;
                }
            ],
            oma_work_phone:[
                v => {
                    if(v) return /^\(\d{3}\) \d{3}-\d{4}$/.test(v) || 'Work phone is invalid';
                    else return true;
                }
            ],
            oma_work_phone_ext:[
                v => {
                    if(v) return /^\d{1,10}$/.test(v) || 'Work extension must be a number';
                    else return true;
                }
            ]
        },
        masks:{
            phone: '(###) ###-####'
        }
    }),
    computed:{
        /*
        oma_hiredate: {
            get(){
                return this.$store.state.oma_hiredate;
            },
            set(value){
                this.$store.state.oma_hiredate = value+'-01';
            }
        },*/
        oma_work_email:{
            get(){
                return this.$store.state.oma_work_email;
            },
            set(value){
                this.$store.state.oma_work_email = value;
            }
        },
        oma_work_phone:{
            get(){
                return this.$store.state.oma_work_phone;
            },
            set(value){
                this.$store.state.oma_work_phone = value;
            }
        },
        oma_work_phone_ext:{
            get(){
                return this.$store.state.oma_work_phone_ext;
            },
            set(value){
                this.$store.state.oma_work_phone_ext = value;
            }
        },
        oma_barg_unit_id:{
            get(){
                return this.$store.state.oma_barg_unit_id;
            },
            set(value){
                this.$store.state.oma_barg_unit_id = value;
            }
        },
        oma_barg_unit_detail:{
            get(){
                return this.$store.state.oma_barg_unit_detail;
            },
            set(value){
                this.$store.state.oma_barg_unit_detail = value;
            }
        },
        oma_job_classification:{
            get(){
                return this.$store.state.oma_job_classification;
            },
            set(value){
                this.$store.state.oma_job_classification = value;
            }
        },
        oma_school_building_id:{
            get(){
                return this.$store.state.oma_school_building_id;
            },
            set(value){
                this.$store.state.oma_school_building_id = value;
            }
        },
        oma_school_district_id:{
            get(){
                return this.$store.state.oma_school_district_id;
            },
            set(value){
                this.$store.state.oma_school_district_id = value;
            }
        },
        oma_multiple_school_districts_ind:{
            get(){
                return this.$store.state.oma_multiple_school_districts_ind;
            },
            set(value){
                this.$store.state.oma_multiple_school_districts_ind = value;
            }
        },
        formatISOHireDate:{
            get(){
                return this.$store.getters.formattedHireDate;
            }
        }
    },
    methods:{
        get_district_options: async function(){
            const districtPayload = {doCmd: 'get_districts'};
            const get_districts = await axios.post(`${this.$baseURL}/common/mea_common/common_processor.php`, JSON.stringify(districtPayload), {
                headers : {'Content-Type': 'application/json'}
            });
            if(get_districts.data.error > 0){
                this.showError = true;
                this.errorObj = {error:get_districts.data.error, errorref:get_districts.data.errorref, errortext:get_districts.data.errortext};
                this.errorIsFatal=false;
                return;
            }
            this.district_options = get_districts.data.result.filter(v=>v.dist_name == 'Michigan State University');
            this.oma_school_district_id = this.district_options[0].dist_cst_recno;
            this.determine_building_options();

            if(this.building_options.length == 1){
                this.oma_school_building_id = '000000';
            }
        },
        get_jobclass_options: async function(){
            const jcPayload = {doCmd: 'get_job_classifications'};
            const get_jobclass = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(jcPayload), {
                headers : {'Content-Type': 'application/json'}
            });
            if(get_jobclass.data.error > 0){
                this.showError = true;
                this.errorObj = {error:get_jobclass.data.error, errorref:get_jobclass.data.errorref, errortext:get_jobclass.data.errortext};
                this.errorIsFatal=false;
                return;
            }
            this.job_class_options = Object.values(get_jobclass.data.result)
                .filter(v=>v.jc_name != "Other")
                .sort((a,b)=>{
                const jcA = a.jc_name.toUpperCase();
                const jcB = b.jc_name.toUpperCase();
                if(jcA < jcB) return -1;
                else if (jcA > jcB) return 1;
                else return 0
            }).filter(v=> [
                    'Higher Education Faculty',
                    'Library/Media',
                    'Teacher/Instructor',
                    'Other'
                ].includes(v.jc_name)
            );
            this.job_class_options.push({jc_value: "1014", jc_name: "Other", jc_order: "2400"});
        },
        async validate_and_continue(){
            if(!this.$refs.fm_work_info.validate()){
                this.showErrorsOnPage = true;
                return;
            }
            this.showSavingProgress = true;
            if(!this.checked_for_bu){
                this.$store.commit('clear_bu_details');
                const jobClassID = this.job_class_options.filter(jc => jc.jc_name == this.oma_job_classification)[0].jc_value;
                const unitTypePayload = {doCmd:'get_unit_type', district_id:this.oma_school_district_id, classification:jobClassID, app_id: window.sessionStorage.getItem('appID')}
                const get_unit_type = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(unitTypePayload), {
                    headers : {'Content-Type': 'application/json'}
                });
                this.checked_for_bu = true;
                const {data: {error:gut_error, result:gut_result } } = get_unit_type;
                if( gut_error ){
                    //an error occurred or this unit hasn't been mapped yet default to ibl
                    this.$store.state.oma_barg_unit_detail.is_ibl = '1';
                }else{
                    const msuUtsf = Object.values(gut_result).find(v=>v.unit_cst_recno == '662295');
                    this.set_bargaining_unit(msuUtsf);
                }
            }
            // get all the form data to update the db
            const formData = {
                doCmd: 'update_db',
                app_id: window.sessionStorage.getItem('appID'),
                //oma_hiredate: this.oma_hiredate,
                oma_work_email: this.oma_work_email,
                oma_work_phone: this.oma_work_phone,
                oma_work_phone_ext: this.oma_work_phone_ext,
                oma_barg_unit_id: this.oma_barg_unit_id,
                oma_barg_unit_detail: JSON.stringify(this.oma_barg_unit_detail),
                oma_job_classification: this.oma_job_classification,
                oma_school_building_id: this.oma_school_building_id,
                oma_school_district_id: this.oma_school_district_id,
                oma_multiple_school_districts_ind: this.oma_multiple_school_districts_ind
            }
            this.log_activity(`Attempting to update database with work info`);

            const update_db = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(formData), {
                headers : {'Content-Type': 'application/json'}
            });

            if(update_db.data.result.has_error){
                this.showError = true;
                let errors = [];
                update_db.data.result.fail.forEach(v => errors.push(`REF# ${v.errorref} - ${v.errortext} <br/>`))
                this.errorObj = {errorref:false, errortext:errors.join('')};
                this.errorIsFatal = false;
                this.showSavingProgress = false;
                return false;
            }

            if(update_db.data.error > 0){
                this.showError = true;
                this.errorObj = {errorref:update_db.data.errorref, errortext:update_db.data.errortext};
                this.errorIsFatal = false;
                this.showSavingProgress = false;
                return false;
            }

            const update_step_payload = {doCmd:'update_app_step', app_id: window.sessionStorage.getItem('appID'), number: 2};
            const update_app_step = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(update_step_payload), {
                headers : {'Content-Type': 'application/json'}
            });
            const {data: {error:uas_error,errorref:uas_errorref, errortext:uas_errortext}} = update_app_step;
            if(uas_error > 0){
                this.showError = true;
                this.errorObj = {error:uas_error, errorref:uas_errorref, errortext:uas_errortext};
                this.errorIsFatal=false;
            }
            this.showSavingProgress = false;
            this.$emit('next-step');
        },
        set_bargaining_unit(unit){
            if( unit.unit_cst_recno == '000000' ){
                const ibl_units_in_dist = this.potentialUnits.filter(v=> v.unit_cst_recno != '000000' && v.is_ibl == '1');
                if(ibl_units_in_dist.length == 0){
                    unit.is_ibl = '0';
                }
            }
            this.oma_barg_unit_detail = unit;
            this.oma_barg_unit_id = unit.unit_cst_recno;

            //if this is showing then this is coming from that emit event so close the modal and validate/continue
            if(this.showMultiplePossibleUnits){
                this.log_activity(`Applicant identified ${this.oma_barg_unit_detail.unit_name} as their unit. This unit is an ${this.oma_barg_unit_detail.is_ibl ? 'IBL':'LBL'} unit.`);
                this.showMultiplePossibleUnits = false;
                this.validate_and_continue();
            }
        },
        determine_building_options(){
            this.building_options = [];
            //this.oma_school_building_id = null;
            if(!this.oma_school_district_id) return false;
            this.checked_for_bu = false; //reset this just in case it changes after we've checked for a unit
            const dist_details = this.district_options.filter(dist => dist.dist_cst_recno == this.oma_school_district_id );

            this.building_options = dist_details.length == 0 ? []
                                    : Object.values(dist_details[0].dist_bldg).sort((a,b)=>{
                                        const bldgA = a.bldg_name.toUpperCase(); // ignore upper and lowercase
                                        const bldgB = b.bldg_name.toUpperCase(); // ignore upper and lowercase
                                        if (bldgA < bldgB) {
                                            return -1;
                                        }
                                        if (bldgA > bldgB) {
                                            return 1;
                                        }
                                        // names must be equal
                                        return 0;
                                    });

            this.building_options.push({bldg_cst_recno:'000000', bldg_name:'My building is not listed'});
            //check to make sure that the value of the school building is actually in the list of options, otherwise set it to null
            if(this.building_options.filter(v => v.bldg_cst_recno == this.oma_school_building_id).length === 0 || this.oma_school_building_id == '000000' ){ this.oma_school_building_id = null; }
        }
    },
    mounted:function(){
      this.get_district_options();
      this.get_jobclass_options();
    },
    watch:{
        oma_multiple_school_districts_ind: function(){
            if(this.oma_multiple_school_districts_ind == 1 && !this.multipleDistrictsShown){
                this.showMultipleDistrict = true;
            }
        },
        oma_job_classification: function(){
            this.checked_for_bu = false; //reset this just in case it changes after we've checked for a unit
        }
    }
  }
</script>

<style scoped>
</style>